import { createSlice } from '@reduxjs/toolkit';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';

const initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: ""
};

const updateProfileImageSlice = createSlice({
  name: 'updateProfileImageSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProfileImage.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(updateProfileImage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(updateProfileImage.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error.message;
      });
  },
});

export default updateProfileImageSlice.reducer;
